"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _style = require("./style");

var _excluded = ["value", "flag", "disabled", "bubble", "tooltip", "selected", "onSelect", "children"];

var _this = void 0;

/**
 * RegionMenu.Item
 * @description 地域选择菜单项
 */
var Item = function Item(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var value = _ref.value,
      flag = _ref.flag,
      disabled = _ref.disabled,
      bubble = _ref.bubble,
      tooltip = _ref.tooltip,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var onClick = function onClick() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (disabled) {
      return;
    }

    onSelect(value);
  }.bind(this);

  var renderItem = function renderItem() {
    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_style.StyledItemWrapper, (0, _extends2["default"])({
      selected: selected,
      disabled: disabled,
      onClick: onClick
    }, others), /*#__PURE__*/_react["default"].createElement(_reactComponents.Combine, null, flag && /*#__PURE__*/_react["default"].createElement(_style.StyledRegionFlag, {
      id: flag,
      disabled: disabled
    }), children, (bubble === null || bubble === void 0 ? void 0 : bubble.bubble) && /*#__PURE__*/_react["default"].createElement(_style.StyledBadge, (0, _extends2["default"])({
      styleType: "yellow",
      value: bubble === null || bubble === void 0 ? void 0 : bubble.bubble
    }, bubble))));
  }.bind(this);

  return tooltip ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, tooltip, renderItem()) : renderItem();
}.bind(void 0);

Item.propTypes = {
  /**
   * item的唯一键
   */
  value: _propTypes["default"].any,

  /**
   * 国旗/区旗图标ID
   */
  flag: _propTypes["default"].string,

  /**
   * 是否禁用
   */
  disabled: _propTypes["default"].bool,

  /**
   * 角标气泡配置，默认不显示
   */
  bubble: _propTypes["default"].object,

  /**
   * tooltip配置，默认不显示
   */
  tooltip: _propTypes["default"].object,

  /** @ignore */
  selected: _propTypes["default"].bool,

  /** @ignore */
  onSelect: _propTypes["default"].func,

  /** @ignore */
  children: _propTypes["default"].node
};
Item.defaultProps = {};
var _default = Item;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/RegionMenu/Item.js
// module id = 2143
// module chunks = 6 7 17 18